<template>
	<v-app v-if="middlewareExecuted">
		<v-main>
			<v-container fluid
						 class="pa-0 pa-md-3 full-height align-start flex-column justify-center"
						 fill-height>
				<rmp-spinner-loader/>
			</v-container>
		</v-main>
	</v-app>
	<router-view v-else/>
</template>

<script setup lang="ts">
import RmpSpinnerLoader from "@rmp/core/components/loaders/common/RmpSpinnerLoader.vue";
import { useAppStore } from "@rmp/core/stores/appStore";
import { storeToRefs } from "pinia";

const appStore = useAppStore();
const { middlewareExecuted } = storeToRefs(appStore);
</script>
